import { useMemo } from 'react';
import useScreenSize from '../../../hooks/useScreenSize';
import { Location } from './types';

export const LOCATION_HEIGHT = 55;
export const TOWNSHIP_HEIGHT = 44;
export const TABLET_COLUMNS_COUNT = 2;
export const DESKTOP_COLUMNS_COUNT = 4;

export const useGetMaxBlockHeight = (
  townships: Location[] | null,
  locations: Location[]
) => {
  const { isLarge, isMedium } = useScreenSize();

  const columnsCount = useMemo(() => {
    if (isLarge) return DESKTOP_COLUMNS_COUNT;
    if (isMedium) return TABLET_COLUMNS_COUNT;
    return 1;
  }, [isLarge, isMedium]);

  const maxBlockHeight = useMemo(() => {
    const locationsHeight =
      (townships || []).length * TOWNSHIP_HEIGHT +
      LOCATION_HEIGHT * locations.length;
    const totalHeight = townships
      ? locationsHeight + locations.length
      : locationsHeight;

    const roundedHeight = Math.ceil(totalHeight / columnsCount);

    return townships
      ? roundedHeight + LOCATION_HEIGHT / 2
      : roundedHeight + LOCATION_HEIGHT;
  }, [townships, locations.length, columnsCount]);

  return maxBlockHeight;
};
